<div class="ss-host">
  @if (cell()) {
    <button
      class="ss-trigger-cell mis-cell-field"
      type="button"
      aria-haspopup="listbox"
      [attr.aria-expanded]="open()"
      [attr.aria-label]="ariaLabel() || displayLabel()"
      [attr.title]="displayLabel()"
      (click)="toggle()"
    >
      @if (selectedOption(); as opt) {
        <span class="ss-trigger-cell__value">
          @if (opt.logo) {
            <img [src]="opt.logo" class="ss-opt-logo" alt="" />
          }
          {{ opt.label }}
        </span>
      } @else {
        <span class="ss-trigger-cell__value ss-trigger-cell__placeholder">{{
          placeholder()
        }}</span>
      }
      <i
        class="ri-edit-line ss-trigger-cell__edit"
        aria-hidden="true"
      ></i>
      <i
        class="ri-arrow-down-s-line ss-trigger-cell__chevron"
        [class.rotated]="open()"
        aria-hidden="true"
      ></i>
    </button>
  } @else {
    <button
      class="ss-trigger"
      type="button"
      aria-haspopup="listbox"
      [attr.aria-expanded]="open()"
      [attr.aria-label]="ariaLabel() || null"
      (click)="toggle()"
    >
      @if (selectedOption(); as opt) {
        <span class="ss-selected">
          @if (opt.logo) {
            <img [src]="opt.logo" class="ss-opt-logo" alt="" />
          }
          {{ opt.label }}
        </span>
      } @else {
        <span class="ss-placeholder">{{ placeholder() }}</span>
      }
      <i
        class="ri-arrow-down-s-line ss-chevron text-sm"
        [class.rotated]="open()"
        aria-hidden="true"
      ></i>
    </button>
  }
</div>

<ng-template #dropdownTpl>
  <div
    class="ss-dropdown"
    role="listbox"
    [style.top.px]="dropdownTop() ?? null"
    [style.bottom.px]="dropdownBottom() ?? null"
    [style.left.px]="dropdownLeft() ?? null"
    [style.width.px]="dropdownWidth()"
    [style.max-height.px]="dropdownMaxHeight()"
  >
    <div class="ss-search-wrap">
      <i class="ri-search-line ss-search-icon text-sm" aria-hidden="true"></i>
      <input
        class="ss-search"
        type="text"
        [placeholder]="searchPlaceholder()"
        [ngModel]="searchQuery()"
        (ngModelChange)="searchQuery.set($event)"
        (keydown.escape)="close(); $event.stopPropagation()"
        (keydown.enter)="selectFirstMatch()"
      />
      @if (searchQuery()) {
        <button
          class="ss-search-clear"
          type="button"
          aria-label="Vymazat hledání"
          (click)="searchQuery.set(''); $event.stopPropagation()"
        >
          <i class="ri-close-line text-xs" aria-hidden="true"></i>
        </button>
      }
    </div>
    <div class="ss-options">
      @if (allLabel()) {
        <button
          class="ss-option"
          [class.active]="!value()"
          type="button"
          role="option"
          [attr.aria-selected]="!value()"
          (click)="select(''); $event.stopPropagation()"
        >
          {{ allLabel() }}
        </button>
      }
      @for (opt of filteredOptions(); track opt.id) {
        @if (showGroupHeader(opt, $index)) {
          <div class="ss-group-label">{{ opt.group }}</div>
        }
        <button
          class="ss-option"
          [class.active]="opt.id === value()"
          type="button"
          role="option"
          [attr.aria-selected]="opt.id === value()"
          (click)="select(opt.id); $event.stopPropagation()"
        >
          @if (opt.logo) {
            <img [src]="opt.logo" class="ss-opt-logo" alt="" />
          }
          {{ opt.label }}
        </button>
      }
      @if (filteredOptions().length === 0) {
        <div class="ss-empty">{{ noResultsLabel() }}</div>
      }
    </div>
  </div>
</ng-template>
